module.exports = "<div class=\"sidebar\">\r\n  <app-sidebar-menu></app-sidebar-menu>\r\n  <button class=\"sidebar-minimizer\" type=\"button\" appSidebarMinimizer appBrandMinimizer></button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/www/backend/src/app/core/components/layout/sidebar/sidebar.component.html
// module id = ../../../../../src/app/core/components/layout/sidebar/sidebar.component.html
// module chunks = main